export default {
  readMore: { is: 'Lesa nánar' },
};
